import React from 'react';
import './what-to-do.css';
import WhatToDoCard from '../what-to-do-card/WhatToDoCard';
import TableChat1 from '../elements-icons/TableChat1';
import ChatBubbles1 from '../elements-icons/ChatBubbles1';
import DocumentsFind1 from '../elements-icons/DocumentsFind1';
import CogTimer1 from '../elements-icons/CogTimer1';
import BoxBurstingStars1 from '../elements-icons/BoxBurstingStars1';
import PresentationFind1 from '../elements-icons/PresentationFind1';
import TechInHand1 from '../elements-icons/TechInHand1';
import AINeural1 from '../elements-icons/AINeural1';
import TechLines2 from '../elements-svg/TechLines2';
import TechLines3 from '../elements-svg/TechLines3';

const WhatToDo = () => {
  
  const cardContent = [
    {
      url: '',
      cardClass: 'bg-straight-gradient-purple text-lt',
      icon: <TableChat1 svgClass='icon-md' pathClass='icon-pink' />,
      iconClass: 'icon-card-circle-md icon-container bg-white',
      title: 'Content Creation',
      content: 'Drafting blog posts, social media content, or even book outlines becomes a breeze with the right prompts.',
    },
    {
      url: '',
      cardClass: 'bg-off-white',
      icon: <ChatBubbles1 svgClass='icon-md' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-md icon-container bg-slanted-gradient-green',
      title: 'Language Learning',
      content: 'Craft prompts to get translations, practice conversations in a new language, or understand grammatical nuances.',
    },
    {
      url: '',
      cardClass: 'bg-off-white',
      icon: <DocumentsFind1 svgClass='icon-md' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-md icon-container bg-slanted-gradient-yellow',
      title: 'Research Assistance',
      content: 'Unearth valuable insights or summaries from dense materials, making academic or market research more efficient.',
    },
    {
      url: '',
      cardClass: 'bg-off-white',
      icon: <CogTimer1 svgClass='icon-md' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-md icon-container bg-slanted-gradient-purple',
      title: 'Personal Productivity',
      content: 'From generating to-do lists based on your week\'s priorities to brainstorming session ideas, AI can be your personal assistant.',
    },
    {
      url: '',
      cardClass: 'bg-off-white',
      icon: <BoxBurstingStars1 svgClass='icon-md' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-md icon-container bg-slanted-gradient-pink',
      title: 'Entertainment',
      content: 'Spin up tales, create unique characters, or even plot twists for your next screenplay or novel.',
    },
    {
      url: '',
      cardClass: 'bg-off-white',
      icon: <PresentationFind1 svgClass='icon-md' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-md icon-container bg-slanted-gradient-orange',
      title: 'Business Strategy',
      content: 'Generate SWOT analyses, industry trends, or even brainstorm innovative product ideas with a little AI nudge.',
    },
    {
      url: '',
      cardClass: 'bg-off-white',
      icon: <TechInHand1 svgClass='icon-md' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-md icon-container bg-slanted-gradient-blue',
      title: 'Technical Queries',
      content: 'Whether you\'re stuck with a coding challenge or want to understand a complex mathematical concept, a well-crafted prompt can guide the way.',
    },
    {
      url: '',
      cardClass: 'bg-off-white',
      icon: <AINeural1 svgClass='icon-md' pathClass='icon-wht' />,
      iconClass: 'icon-card-circle-md icon-container bg-slanted-gradient-light-pink',
      title: 'Happy Prompting!',
      content: 'Remember, it\'s a two-way street. You bring the curiosity, and the AI brings the insights.',
    },
  ]
  
  return (
    <section className='section-what-to-do'>
      <div className='section-what-to-do-svg-left'>
        <TechLines2 width='300px' />
      </div>
      <div className='section-what-to-do-svg-right'>
        <TechLines3 width='350px' />
      </div>
      <div className='wrapper-what-to-do-top'>
        <h3 className='title-sub-1'>
          What can we do with this?
        </h3>
        <p className='paragraph-dk'>
          From content creation to research assistance, a carefully chosen prompt can be your key to unlock AI's potential in a multitude of tasks.
        </p>
        <p className='paragraph-dk semi-bold'>
          Here are a few ideas to get you started!
        </p>
      </div>
      <div className='wrapper-what-to-do-bottom'>
        {cardContent.map((card, index) =>
          <WhatToDoCard key={index} card={card} index={index} />
        )}
      </div>
    </section>
  );
}

export default WhatToDo;
